import React from 'react';
import type { ExternalEvent } from '../types';
import { PlusIcon, SparklesIcon } from './icons/PlaybackIcons';

interface ExternalEventCardProps {
    event: ExternalEvent;
    onPlan: (event: ExternalEvent) => void;
    onCreate: (event: ExternalEvent) => void;
    isPlanned: boolean;
    isProcessing: boolean;
    showCreate?: boolean;
}

const ExternalEventCard: React.FC<ExternalEventCardProps> = ({ event, onPlan, onCreate, isPlanned, isProcessing, showCreate }) => {
    return (
        <div className="bg-gray-800 rounded-lg border border-gray-700 p-4 flex flex-col h-full shadow-lg hover:border-gray-600 transition-colors">
            <div className="flex-grow">
                <div className="flex justify-between items-start mb-2">
                    <span className="bg-cyan-900/50 text-cyan-400 text-xs font-bold px-2 py-1 rounded uppercase tracking-wide">
                        Official Event
                    </span>
                    {event.websiteUrl && (
                        <a href={event.websiteUrl} target="_blank" rel="noreferrer" className="text-xs text-gray-500 hover:text-cyan-400">
                            View Website ↗
                        </a>
                    )}
                </div>
                <h3 className="text-lg font-bold text-white mb-1 line-clamp-2">{event.name}</h3>
                <div className="text-sm text-gray-400 space-y-1">
                    <p className="flex items-center gap-2">
                        <span>📅</span>
                        {new Date(event.date).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
                    </p>
                    <p className="flex items-center gap-2">
                        <span>📍</span>
                        {event.location}
                    </p>
                </div>
            </div>

            <div className={`mt-4 grid gap-2 pt-4 border-t border-gray-700 ${showCreate ? 'grid-cols-2' : 'grid-cols-1'}`}>
                <button
                    onClick={() => onPlan(event)}
                    disabled={isPlanned || isProcessing}
                    className={`flex items-center justify-center gap-1 py-2 px-3 rounded-md text-xs font-bold transition-colors ${
                        isPlanned 
                        ? 'bg-green-900/30 text-green-400 border border-green-800 cursor-default' 
                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600 hover:text-white'
                    }`}
                >
                    {isPlanned ? 'Planned' : 'Add to Calendar'}
                </button>
                {showCreate && (
                    <button
                        onClick={() => onCreate(event)}
                        className="flex items-center justify-center gap-1 py-2 px-3 bg-cyan-600 text-white rounded-md text-xs font-bold hover:bg-cyan-500 transition-colors shadow-lg shadow-cyan-500/20"
                    >
                        <SparklesIcon className="w-3 h-3" />
                        Create Race
                    </button>
                )}
            </div>
        </div>
    );
};

export default ExternalEventCard;